import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { MobileOrderSummaryHeight } from '../../common/PaymentSummary/MobilePaymentSummary.style';
import { getColor } from '../../common/UICommon';
import { ContentBoxWrapper } from '../../common/v2/Box/Box.style';
import { TermsLabel } from '../../styledComponent/SignUpComponents.style';
import { ContentCol, TwoSidedLayout } from '../../common/v2/TwoSidedLayout/TwoSidedLayout.style';

const layoutStyleWithPaymentSummary = (showPaymentSummary: boolean) => css`
  @media (max-width: ${TabletWidth}px) {
    padding-top: ${showPaymentSummary ? 0 : MobileOrderSummaryHeight}px;
  }
`;

export const SignupWithPaymentTwoSidedLayout = styled(TwoSidedLayout)<{ showPaymentSummary: boolean }>`
  ${({ showPaymentSummary }) => showPaymentSummary && layoutStyleWithPaymentSummary(showPaymentSummary)};
`;

export const SignupWithPaymentSummaryCol = styled(ContentCol)`
  background-color: ${getColor('LIGHT_CREAM')};
  min-height: 100vh;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const CheckoutFormContentBoxWrapper = styled(ContentBoxWrapper)`
  margin-bottom: 32px;
`;

export const SubmitButtonWrapper = styled.div`
  max-width: 375px;
  margin: auto;
  margin-bottom: 12px;
`;

export const TermsLabelWrapper = styled(TermsLabel)`
  text-align: center;
  margin-bottom: 24px;
`;

export const ThinLabel = styled.p`
  font-size: 14px;
  color: ${getColor('BLACK')};
  font-weight: 400;
  margin-bottom: 8px;
`;
